import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useState,useEffect } from 'react';
import { Card, Toast, ToastContainer } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import LegalWarning from '../components/legalwarning';
import styles from '../styles/auth-pages.module.css';
import LoginForm from './login-form';

function Login({showRecoverPassword,returnUrl,passwordReset}){

    useEffect(() => {
        document.title = "MFP - Login";
    },[]);

    const navigate = useNavigate();
    const [showPassReset,setShowPassReset] = useState(passwordReset);

    const getPostLoginUrl = (session) => {
        return returnUrl;
    };
    
    return(
        <>
            <ToastContainer className="toastcontainer" position='top-center'>
                {
                    showPassReset &&
                    <Toast
                        onClose={() => setShowPassReset(false)}
                        bg='success'
                        delay={7000}
                        animation={true}
                        autohide={true}
                    >
                        <Toast.Header>
                            <strong className="me-auto">MFP Information System</strong>
                            <small>Just Now</small>
                        </Toast.Header>
                        <Toast.Body className={'text-white'}>
                            Your password was successfully reset!
                        </Toast.Body>       
                    </Toast>
                }
            </ToastContainer>
            <Row className={styles.authRow}>
                <Col xs={12} className={styles.authCol}>
                    <div className={styles.legalWrap}>
                        <div className={styles.legalDesktop}>
                            <LegalWarning />
                        </div>
                    </div>
                    <Card className={styles.authCard}>
                        <Card.Img className={styles.banner} variant="top" src='../KTMAHEADER.png' alt="Money Follows The Person Banner"/>
                        <Card.Body className={styles.cardBody}>
                            <h3 className={styles.title}>MFP Login</h3>
                            <p className={styles.subtitle}>
                                Start with your username and we will guide you to the preferred sign-in method for that account.
                                Password plus emailed one-time code is available only until the first passkey is enrolled.
                                After that, the account signs in with passkeys only.
                            </p>
                            <LoginForm
                                secondaryActionLabel="Forgot Password?"
                                onSecondaryAction={showRecoverPassword}
                                secondaryActionVisibility="password"
                                onSuccess={(session) => navigate(getPostLoginUrl(session))}
                            />
                        </Card.Body>
                    </Card>
                    <details className={styles.legalMobile}>
                        <summary className={styles.legalMobileSummary}>Legal Warning</summary>
                        <div className={styles.legalMobileBody}>
                            <LegalWarning />
                        </div>
                    </details>
                </Col>
            </Row>
        </>
    )
}
export default Login;
